<template>
<div class="chapter">
<div class="inner_page">
<p class="p-p2" style="text-align: center;">the</p>
<p class="p-p2" style="text-align: center;">DEVIL TREE <span class="s-t">II</span></p>
<p class="p-p4"><span class="s-t1">The Calling</span></p>
<p class="p-p5">KEITH ROMMEL</p>
<p class="whitespace"> </p>
<p class="p-p6">INSPIRED BY THE LEGEND OF THE DEVIL TREE</p>
<p class="p-p6">IN PORT SAINT LUCIE, FLORIDA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?6600eb60